import { setGrabbedData } from "../Cabinet/stateSlice";
import { Sunday } from "./types";
import axios from "axios";

export const formatDate = (dateString: string | number | Date) => {
  const formattedDate = new Date(dateString);
  const dateArray = formattedDate.toString().split(" ");
  const timeArray = dateArray[4].split(":");
  timeArray.pop();
  let time = timeArray.join(":");

  const hour = parseInt(timeArray[0]);
  if (hour > 12) {
    timeArray[0] = (hour - 12).toString();
    time = timeArray.join(":") + " PM";
  } else {
    time += " AM";
  }
  const m_d_y = dateArray[1] + " " + dateArray[2] + ", " + dateArray[3];
  return [m_d_y, time];
};

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const calculateSundays = (start: number, end: number) => {
  const sundays = [];
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDate = today.getDate();

  for (let year = start; year <= end; year++) {
    for (let month = 0; month < 12; month++) {
      if (year === currentYear && month > currentMonth) break;

      let date = new Date(year, month, 1);
      while (date.getDay() !== 0) date.setDate(date.getDate() + 1);

      while (date.getMonth() === month) {
        if (
          year === currentYear &&
          month === currentMonth &&
          date.getDate() > currentDate
        )
          break;

        sundays.push([
          months[date.getMonth()],
          date.getDate(),
          date.getFullYear(),
        ]);
        date.setDate(date.getDate() + 7);
      }
    }
  }

  return sundays;
};

export const getStandardDeviation = (arr: any[]) => {
  const n = arr.length;
  const mean = arr.reduce((a: any, b: any) => a + b) / n;
  return Math.sqrt(
    arr
      .map((x: number) => Math.pow(x - mean, 2))
      .reduce((a: any, b: any) => a + b) / n
  );
};

export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const fetchEvent = (
  setDisabledLeft: (arg0: boolean) => void,
  setDisabledRight: (arg0: boolean) => void,
  searchParams: any,
  setDisplayTopic: (arg0: boolean) => void,
  setLoading?: (arg0: boolean) => void,
  setWeek?: (arg0: number) => void,
  setView?: (arg0: string) => void,
  sundays?: Sunday[],
  setNavigate?: (arg0: any) => void,
  setThoughts?: (arg0: any) => void,
  setGrabbedData?: (arg0: boolean) => void
) => {
  setLoading!(true);
  if (!sundays) return;
  const setDateParams = (newWeek: number) => {
    if (setWeek) setWeek(newWeek);
    setDisabledLeft(newWeek === 0);
    setDisabledRight(sundays ? newWeek === sundays.length - 1 : true);
  };
  let found = false;
  for (const [key, value] of searchParams.entries()) {
    if (key === "date") {
      found = true;
      const [month, day, year] = value.split("-");
      const newWeek = sundays.findIndex(
        (sunday: Sunday) =>
          sunday[0] === month &&
          sunday[1] === parseInt(day) &&
          sunday[2] === parseInt(year)
      );

      if (newWeek > -1) {
        setDateParams(newWeek);
      }
    }
    if (key === "theme") {
      found = true;
      setView!(value);
      setDisplayTopic(true);
    }
  }
  if (!found) {
    setDateParams(sundays.length - 1);
    setWeek!(sundays.length - 1);
  }
  setLoading!(false);
};

export const fetchThoughtsByDate = async (
  day: Date,
  setThoughts?: (arg0: any) => void
) => {
  setGrabbedData(false);
  let date = day.toISOString();
  try {
    const res = await axios.post(
      "https://us-central1-thought-cabinet.cloudfunctions.net/app/getThoughtsByDate",
      {
        sunday: date,
      }
    );
    res.data.thoughts.forEach((thought: any) => {
      for (const key in thought) {
        if (isJsonString(thought[key])) {
          thought[key] = JSON.parse(thought[key]);
        }
      }
    });
    setThoughts!(res.data.thoughts);
    setGrabbedData(true);
    res.data = null;
  } catch (error) {
    console.error("Error fetching thoughts:", error);
  }
};

export const fetchThoughtsByTheme = async (
  theme: string,
  setThoughts?: (arg0: any) => void,
  setLoading?: (arg0: boolean) => void
) => {
  setLoading!(true);
  setGrabbedData(false);
  try {
    const res = await axios.post(
      "https://us-central1-thought-cabinet.cloudfunctions.net/app/getThoughtsByTheme",
      {
        theme: theme,
      }
    );
    res.data.thoughts.forEach((thought: any) => {
      for (const key in thought) {
        if (isJsonString(thought[key])) {
          thought[key] = JSON.parse(thought[key]);
        }
      }
    });
    res.data.thoughts.forEach((thought: any) => {
      thought.recent = 1;
      let labels = thought.label.split(", ");
      labels = labels.filter((label: string) => label !== theme);
      thought.label = labels.join(", ");
    });
    setThoughts!(res.data.thoughts);
    setGrabbedData(true);
    setLoading!(false);
    res.data = null;
  } catch (error) {
    console.error("Error fetching thoughts:", error);
  }
};

export const fetchThemes = async (setThemes: (arg0: any) => void) => {
  try {
    const res = await axios.get(
      "https://us-central1-thought-cabinet.cloudfunctions.net/app/getAllThemes"
    );

    // res.data.themes.forEach((theme: string, index: number) => {
    //   res.data.themes[index] = theme.trim();
    // });

    const themes = Array.from(new Set(res.data.themes));
    setThemes(themes);
    res.data = null;
  } catch (error) {
    console.error("Error fetching themes:", error);
  }
};
